import { States } from "../../../../../../../common/constants/states";

class AdminSchoolsLocationsZonesIndexController {
  constructor(
    $state,
    LocationsModel,
    SchoolService,
    ZonesModel,
    $stateParams,
    FlashService,
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SchoolService = SchoolService;
    this.ZonesModel = ZonesModel;
    this.FlashService = FlashService;
    this.states = States;
    this.busy = false;

    this.setZoneBgColor = this.setZoneBgColor.bind(this);
    this.setZoneTextColor = this.setZoneTextColor.bind(this);

    LocationsModel.getLocationByID($stateParams.locationId).then((response) => {
      this.location = response;
    });
    LocationsModel.getZones($stateParams.locationId).then((response) => {
      this.zones = response.zones;
    });
  }

  updateZone(zone) {
    this.busy = true;
    this.ZonesModel.editFallbackLocation(zone)
      .then((response) => {
        this.FlashService.setMessage({
          message: response.message,
          type: "success",
        });
        this.busy = false;
      })
      .catch((Error) => {
        this.busy = false;
      });
  }

  setZoneBgColor(color) {
    this.zone.bg_color = color;
  }

  setZoneTextColor(color) {
    this.zone.text_color = color;
  }

  saveZoneColors(zone) {
    this.busy = true;
    this.ZonesModel.editColors(zone)
      .then((response) => {
        this.FlashService.setMessage({
          message: response.message,
          type: "success",
        });
        const updated = response.zone;
        const i = this.zones.findIndex((z) => z.id === updated.id);
        if (i !== -1) {
          this.zones[i].bg_color = updated.bg_color;
          this.zones[i].text_color = updated.text_color;
        }
        this.zone.bg_color = updated.bg_color;
        this.zone.text_color = updated.text_color;
        this.busy = false;
      })
      .catch(() => {
        this.busy = false;
      });
  }

  resetZoneColors(zone) {
    zone.bg_color = null;
    zone.text_color = null;
    this.saveZoneColors(zone);
  }
}
AdminSchoolsLocationsZonesIndexController.$inject = [
  "$state",
  "LocationsModel",
  "SchoolService",
  "ZonesModel",
  "$stateParams",
  "FlashService",
];
export default AdminSchoolsLocationsZonesIndexController;
